/* Section Banner 2026 — press logos marquee (mobile only).
   The logo set is rendered twice in the markup (the duplicate is hidden and
   aria-hidden). This script only decides the mode: on mobile, if one set
   doesn't fit the strip, it adds .is-marquee — that shows the duplicate and
   starts the pure-CSS animation (0 → -50% of the track = exactly one set,
   so the loop restarts without any jump). Desktop always keeps the static
   row (logos shrink to fit via CSS). No cloning, no measured offsets.
   Re-syncs on resize, image load and in the theme editor. */
(function () {
  var SPEED = 40; /* px per second */
  var MOBILE = window.matchMedia('(max-width: 768px)'); /* must match the CSS media query */

  function sync(strip) {
    var track = strip.querySelector('.press_track');
    var set = track && track.querySelector('.press_set');
    if (!set || !set.children.length) return;

    strip.classList.remove('is-marquee');
    track.style.removeProperty('--press-duration');

    /* Marquee is mobile-only; desktop always keeps the static row. */
    if (!MOBILE.matches) return;

    var overflows = set.scrollWidth > strip.clientWidth + 1;
    if (!overflows) return;

    strip.classList.add('is-marquee');
    /* One loop = one set width (track slides -50%); constant speed. */
    track.style.setProperty('--press-duration', (set.offsetWidth / SPEED) + 's');
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-press-strip]').forEach(sync);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll();
    /* Lazy logo images can land after DOMContentLoaded and change the set
       width — re-measure once everything is in. */
    window.addEventListener('load', function () {
      initAll();
    });
  });

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      initAll();
    }, 150);
  });

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
